/**
 * Settings Context
 * Shared state and functions for organization settings tabs
 */
import { createContext, useContext } from "react";

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};

export const SettingsProvider = SettingsContext.Provider;

export default SettingsContext;
